import Vue from 'vue';
import getInitialState from './reconfiguration.state';

export const payloadFormatter = payload => (!payload || payload === 'none') ? '' : payload;

export default {
  SET_TASK(state, taskId) {
    state.taskId = payloadFormatter(taskId);
  },

  SET_TASK_STATE(state, status) {
    state.taskStatus = payloadFormatter(status);
  },

  SET_TASK_PROGRESS(state, progressValue) {
    state.progress = progressValue || 0;
  },

  SET_OPERATION(state, operationName) {
    state.operation = payloadFormatter(operationName);
  },

  SET_OPERATION_DETAILS(state, data) {
    state.data = data || {};
  },

  SET_ALERTS(state, alerts = []) {
    state.alerts = alerts;
  },

  SET_REASON(state, reason = '') {
    state.reason = reason;
  },

  SET_SINGLE_INTERFACE_MIGRATION(state, value) {
    state.singleInterfaceMigration = value;
  },

  SET_NETWORK_CONFIGURATION(state, { networkId, configuration }) {
    Vue.set(state.networksConfiguration, networkId, configuration);
  },

  FLUSH_STATE(state) {
    Object.assign(state, getInitialState());
  }
};
